<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <!-- <template #start>
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template> -->
      <template #end>
        <el-button class="exportBtn" type="primary" :loading="btnloading" @click="getExport">
          <i v-if="!btnloading" class="el-icon-folder"></i>
          导出
        </el-button>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      formInline: {
        ischeck: 2,
      },
      cols: [
        { prop: "order_num", label: "订单编号", width: 150 },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        { prop: 'starttime', label: '装货日期', minwidth: 120 },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "inton", label: "装车重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "unton", label: "卸车重量", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/orderdetail2?id=${id}&mode=edit`
            );
          },
        },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>
